module.exports = __webpack_public_path__ + "img/logo-header.f3827779.png";